module.exports = __webpack_public_path__ + "img/signup-guide-03-01.f61465a1.png";